import { render, staticRenderFns } from "./confirm-component.vue?vue&type=template&id=17c699fa&scoped=true&"
import script from "./confirm-component.vue?vue&type=script&lang=js&"
export * from "./confirm-component.vue?vue&type=script&lang=js&"
import style0 from "./confirm-component.vue?vue&type=style&index=0&id=17c699fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c699fa",
  null
  
)

export default component.exports